import Component from '../Component';
import $ from '../../vendor/CustomJquery';

export default class PasswordSwitch extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    this.subscribeToEvents();
    return super.initialize();
  }

  subscribeToEvents() {
    $(document).on('click', '.is-password-switcher', (event) => {
      return this.onClick(event);
    });
  }

  onClick(event) {

    let self = $(event.currentTarget);

    if (self.find('.fa-eye-slash').length > 0) this.show(self);
    else this.hide(self);

    event.preventDefault();
  }

  show(element) {
    let parent = element.closest('.field'),
        input  = parent.find('input'),
        icon   = parent.find('.is-password-switcher i');

    input.attr('type', 'text');
    icon.removeClass('fa-eye-slash').addClass('fa-eye');
  }

  hide(element) {
    let parent = element.closest('.field'),
        input  = parent.find('input'),
        icon   = parent.find('.is-password-switcher i');

    input.attr('type', 'password');
    icon.removeClass('fa-eye').addClass('fa-eye-slash');
  }

}